import { Empty, Skeleton, Typography } from "antd";
import { FileExcelOutlined } from "@ant-design/icons";
import { useTheme } from "../../../contexts/ThemeContext";
import { formatDateTime, plural } from "./additionalInfoUtils";

const { Text } = Typography;

/**
 * A planilha que está valendo. Cada envio substitui o anterior, então há no máximo uma; as
 * ações (ver lançamentos, limpar) ficam no cabeçalho do bloco, na seção.
 */
const CurrentSheet = ({ lote, loading, supportsSales }) => {
  const { theme } = useTheme();

  if (loading && !lote) return <Skeleton active paragraph={{ rows: 1 }} title={false} />;

  if (!lote) {
    return (
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={<Text style={{ fontSize: 13, color: theme.textSecondary }}>Nenhuma planilha enviada ainda</Text>}
        style={{ margin: "8px 0" }}
      />
    );
  }

  const counts = [plural(lote.qtdTitulos ?? 0, "título", "títulos")];
  if (supportsSales) counts.push(plural(lote.qtdVendas ?? 0, "venda", "vendas"));
  const meta = [formatDateTime(lote.criadoEm), lote.criadoPor].filter(Boolean).join("  ·  ");

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0" }}>
      <FileExcelOutlined style={{ fontSize: 20, color: theme.success, flex: "0 0 auto" }} />
      <div style={{ minWidth: 0, flex: 1 }}>
        <Text ellipsis={{ tooltip: lote.nomeArquivo }} style={{ display: "block", fontSize: 13, color: theme.textPrimary }}>
          {lote.nomeArquivo}
        </Text>
        <Text ellipsis style={{ display: "block", fontSize: 12, color: theme.textSecondary }}>
          {meta}
        </Text>
      </div>
      <Text style={{ flex: "0 0 auto", fontSize: 12, color: theme.textSecondary }}>{counts.join(" · ")}</Text>
    </div>
  );
};

export default CurrentSheet;
